<template>
  <div class="fondo_transparente">
    <div class="ventana_modal">
      <XCerrarModal @click="cerrar" id="XCerrar"/>
      <div class="ingreso">
        <div class="textoIngreso">Ingreso</div>
      </div>
      <div class="entradas">
        <input
          type="email"
          v-model="datLogin.email"
          name="correo"
          class="entrada"
          placeholder="E-MAIL">
        <input
          :type="modoPass"
          v-model="datLogin.pass"
          name="pass"
          class="entrada"
          placeholder="PASSWORD"
          @keyup.enter="login">
        <p class="ojo" @click="verPass">&gtcc;</p>
      </div>
      <div class="pieLogin">
        <div class="pieAux">
          <div class="irRegistro" @click="irRegistro">Ir a REGISTRO</div>
          <div class="olvidoPass" @click="olvidoPass">Olvidé mi PASSWORD</div>
        </div>
        <div class="entrar"
          @click="login">
          ENTRAR
        </div>
        <!-- <div class="entrar" @click="irBienvenida">ENTRAR</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import XCerrarModal from '@/components/XCerrarModal.vue'
export default {
  components: { XCerrarModal },
  name: 'Login',
  created () {
    this.URLbase = process.env.VUE_APP_ROOT_API
  },
  data () {
    return {
      modoPass: 'password',
      URLbase: '',
      datLogin: {
        email: '',
        pass: ''
      },
      dataUser: []
    }
  },
  methods: {
    cerrar () {
      this.$router.push('/')
    },
    irRegistro () {
      this.$router.push('/registro')
    },
    irBienvenida () {
      this.$router.push('/bienvenida')
    },
    olvidoPass () {
      this.$router.push('/olvidoPass')
    },
    verPass () {
      this.modoPass = 'text'
      setTimeout(() => { this.modoPass = 'password' }, 2500)
    },
    login () {
      try {
        const url = `${this.URLbase}/users/login`
        const datReg = { mail: this.datLogin.email, pass: this.datLogin.pass }
        axios.post(url, datReg)
          .then(result => {
            if (result.data === 'fail') {
              this.alertJoa('El email o la contraseña no son correctos', 'W')
            } else if (result.data === 'Error') {
              this.alertJoa('Error en el inicio de sesión, intenta otra vez', 'E')
            } else {
              this.dataUser = result.data
              this.fechaExpToken()
              // console.log(this.dataUser)
              this.storeUser(this.dataUser)
              this.irBienvenida()
            }
            if (result.data === 'noName') { this.$router.push('/complementoUser') }
          })
          .catch(error => console.log(error))
      } catch (error) {
        console.log(error)
      }
    },
    fechaExpToken () { // Calcula la fecha de expiración del token a partir de la fecha local y el tiempo de vida
      const fechaActual = new Date()
      const vidaToken = this.dataUser.expToken
      const expiraToken = fechaActual.setSeconds(fechaActual.getSeconds() + vidaToken) // Aquí tenemos la fecha de expiración
      this.dataUser.expiraToken = expiraToken // Aquí se añade a los datos de la sesión de usuario
    },
    storeUser () {
      this.$store.commit('doLogin', this.dataUser)
    }
  }
}
</script>

<style scoped>

.ventana_modal{
    /* background: -webkit-linear-gradient(115deg, rgb(180, 180, 180),rgb(214, 214, 214),rgb(180, 180, 180), rgb(68, 68, 68)); */
    width: 100%;
    max-width: 450px;
    height: 300px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
    border-radius: 5px;
    display: grid;
    /* flex-direction: column; */
    grid-template-rows: 35% 40% 25%;
    justify-items: center;
    align-items: space-around;
    font-family: OpenL;
    /* border:  1px solid rgb(179, 179, 179) */
}
.ingreso{
  background-color: rgba(10, 90, 140, 0.5);
  justify-self: stretch;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  /* border: solid 1px rgb(130, 238, 130); */
  display:grid
}
.textoIngreso{
  justify-self: left;
  align-self: center;
  margin-left: 8%;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 45px;
  font-weight: lighter;
  padding-bottom: 5px;
  color:rgb(251, 155, 82)
}
.entradas{
  justify-self: stretch;
  display: grid;
  row-gap: 1px;
}
.ojo{
  position: absolute;
  color:rgba(10, 90, 140, 0.5);
  font-size: 20px;
  top: 53%;
  right: 20px;
}
.ojo:hover{
  cursor: pointer;
}
.entrada{
  /* border: solid 1px rgb(247, 133, 3); */
  margin: 0px;
  padding-left: 8%;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 18px;
  /* background-color: rgb(224, 227, 230); */
  background-color: var(--gr-fo-for);
  outline:none;
  border:none;
}
.entrada:focus{
  outline:none
}
.pieLogin{
  display:grid;
  /* border: solid 1px rgb(130, 238, 130); */
  grid-template-columns: 55% 45%;
  justify-self: stretch;
  background-color: rgba(10, 90, 140, 0.5);
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  font-weight:400;
}
.pieAux{
  display:flex;
  flex-direction: column;
  /* grid-template-rows: 50% 50%; */
  /* align-items: center; */
  justify-content: space-evenly;
}
.irRegistro, .olvidoPass{
  /* border: solid 1px rgb(130, 238, 130); */
  width: 80%;
  align-self: center;
  border-radius:20px;
  /* background-color: rgba(1, 117, 163, 0.3); */
  color: rgb(251, 155, 82);
  padding: 1.5% 0%;
  border: solid 1px rgba(1, 117, 163, 0);
  cursor: pointer;
}
.irRegistro:hover, .olvidoPass:hover{
  /* background-color: rgba(1, 117, 163, 0.5); */
  border: solid 1px rgba(10, 90, 140, 0.7);
}
.entrar{
  align-self: center;
  font-size: 20px;
  font-weight: lighter;
  width: 80%;
  border-radius:55px;
  padding: 4% 5% 5% 5%;
  color:rgb(251, 155, 82);
  border: solid 1px rgba(1, 117, 163, 0);
  cursor: pointer;
}
.entrar:hover{
  /* background-color: rgba(1, 117, 163, 0.4); */
  border: solid 1px rgba(10, 90, 140, 0.7);
}
@media screen and (max-width: 576px){
  .ventana_modal{
    width: 90%;
    height: 270px;
    grid-template-rows: 34% 38% 28%;
  }
  .textoIngreso{
  font-size: 38px;
  font-weight: 200;
  padding-bottom: 0px;
  }
  .container{
    display: flex;
    flex-direction: column;
    font-size: 1rem
  }
  .irRegistro, .olvidoPass{
  font-size: 90%;
  padding: 1.5% 0%;
  margin: 1.5% 0%;
  border: solid 1px rgba(10, 90, 140, 0.7);
  }
  .entrar{
  border: solid 1px rgba(10, 90, 140, 0.7);
  }
}
</style>
